import { SimilaritySearchAssetDto } from "generated";
import SimilarImageCard from "./SimilarImageCard";

type Props = {
  similarFiles: SimilaritySearchAssetDto[];
};

const SimilarImagesList = ({ similarFiles }: Props) => {
  return (
    <ul className="mb-space100 grid grid-cols-5 gap-x-space125 gap-y-space150">
      {similarFiles.map((file) => (
        <li key={file.id}>
          <SimilarImageCard file={file} />
        </li>
      ))}
    </ul>
  );
};

export default SimilarImagesList;
